import AtomButton from "../../atoms/button/button";
import "./header.scss";
import { useDispatch, useSelector } from "react-redux";
import Product from "../../page/products/Product";
import Industry from "../../page/industries/Industry";
import Solutions from "../../page/solutions/Solutions";
import { useEffect, useRef, useState } from "react";
import Company from "../../page/company/Company";
import Services from "../../page/services/Services";
import MobileNavBar from "./MobileNavBar";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { hide, setActiveIndex, show } from "../../redux/SideBarSlice";
import { setNav_Item } from "../../redux/NavBarSlice";
import { handleScheduleCall } from "../home/home";
import useActiveNavItem from "../../customhooks/UseActiveNavItem";
import { fetchPublishedLogo } from "../../redux/logoSlice";

const HeaderTemplate = () => {
  const [arrow, setArrow] = useState(false);
  const dispatch = useDispatch();
  const SideBarState = useSelector((state) => state.sidebarItem);

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setArrow(false);
      }
    }

    if (arrow) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [arrow]);

  const ActiveNavItem = useSelector((state) => state.navItem.nav_item);
  useActiveNavItem();

  const handleLogoClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      dispatch(hide());
    }
  };

  useEffect(() => {
    console.log("fetching logo");
    dispatch(fetchPublishedLogo());
  }, [dispatch]);

  const { publishedLogo, loading } = useSelector((state) => state.logo);

  console.log("publishedLogo", publishedLogo);

  //  TOGGLE MENU (Same tab open / close)
  const handleMenuTabClick = (tab) => {
    if (SideBarState.visible && SideBarState.source === tab) {
      dispatch(hide());
      dispatch(setActiveIndex(null));
      return;
    }

    dispatch(show(tab));
    dispatch(setNav_Item(tab));
  };

  return (
    <>
    
        <div id="navad">
  <div className="news-wrapper">
    <a
      href="https://www.youtube.com/watch?v=daxKyfRzneA"
      className="news-item"
    >
      <button>NEWS</button>
      <span>
        We have Launched  a new Productivity Product called UtilPulse.
      </span>
    </a>

    {/* duplicate for smooth infinite loop */}
    <a
      href="https://www.youtube.com/watch?v=daxKyfRzneA"
      className="news-item"
    >
      <button>NEWS</button>
      <span>
       We have Launched  a new Productivity Product called UtilPulse.
      </span>
    </a>
  </div>
</div>
      <div className="header">
        {/* <div id="navad">
          <button
            onClick={() =>
              navigate("https://www.youtube.com/watch?v=daxKyfRzneA")
            }
          >
            NEWS
          </button>
          <div id="spacer"></div>
          <a href="https://www.youtube.com/watch?v=daxKyfRzneA">
            We are Launching a new Productivity Product named UtilPulse on 19th Jun 2026 {" "}
          </a>
        </div> */}


        <div className="inner-header">
          <NavLink to="/" onClick={handleLogoClick}>
            <div className="util-logo">
              {/*  <img  loading="lazy"
                src="/images/Long-Logo-Gif.gif"
                alt="company_logo"
                 
                className="orangelogo"
              /> */}

              <img
                loading="lazy"
                src={
                  loading.publish ||
                  !publishedLogo ||
                  publishedLogo.length === 0
                    ? "/images/Long-Logo-Gif.gif"
                    : publishedLogo[0].imageUrl
                }
                alt="company_logo"
                className="orangelogo"
              />
            </div>
          </NavLink>

          <div className="container">
            <MobileNavBar />

            <div className="right-section">
              <ul>
                <li>
                  <NavLink
                    className={`${ActiveNavItem === "hrms" ? "actives" : ""}`}
                    to="/hrms"
                    onClick={() => {
                      dispatch(hide());
                      dispatch(setNav_Item("hrms"));
                      dispatch(setActiveIndex(null));
                    }}
                  >
                    HRMS
                  </NavLink>
                </li>

                 <li>
                  <NavLink
                    className={`${ActiveNavItem === "agentforce" ? "actives" : ""}`}
                    to="/agentforce"
                    onClick={() => {
                      dispatch(hide());
                      dispatch(setNav_Item("agentforce"));
                      dispatch(setActiveIndex(null));
                    }}
                  >
                    Agentforce
                  </NavLink>
                </li> 

                <li>
                  <NavLink
                    className={`${ActiveNavItem === "services" ? "actives" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleMenuTabClick("services");
                    }}
                  >
                    Services
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className={`${ActiveNavItem === "solutions" ? "actives" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleMenuTabClick("solutions");
                    }}
                  >
                    Products
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className={`${ActiveNavItem === "products" ? "actives" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleMenuTabClick("products");
                    }}
                  >
                    Solutions
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className={`${ActiveNavItem === "industries" ? "actives" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleMenuTabClick("industries");
                    }}
                  >
                    Industries
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className={`${ActiveNavItem === "aboutus" ? "actives" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleMenuTabClick("aboutus");
                    }}
                  >
                    About Us
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    className={`${ActiveNavItem === "careers" ? "actives" : ""}`}
                    to="/careers"
                    onClick={() => {
                      dispatch(hide());
                      dispatch(setNav_Item("careers"));
                      dispatch(setActiveIndex(null));
                    }}
                  >
                    Careers
                  </NavLink>
                </li>

                <AtomButton
                  name="primaryButton"
                  color="primary"
                  size="medium"
                  variant="contained"
                  className="ml-3"
                  margin={{ marginLeft: "20px" }}
                  onClick={handleScheduleCall}
                >
                  Schedule a call
                </AtomButton>
              </ul>

              {/* <AtomButton
                name="primaryButton"
                color="primary"
                size="medium"
                variant="contained"
                className="ml-3"
                margin={{ marginLeft: "20px" }}
                onClick={handleScheduleCall}
              >
                Schedule a call
              </AtomButton> */}
            </div>
            {/* <AtomButton
              name="primaryButton"
              color="primary"
              size="medium"
              variant="contained"
              className="ml-3"
              margin={{ marginLeft: "20px" }}
              onClick={handleScheduleCall}
            >
              Schedule a call
            </AtomButton> */}
          </div>
        </div>
      </div>

      {SideBarState.visible && SideBarState.source === "products" && (
        <Product />
      )}
      {SideBarState.visible && SideBarState.source === "industries" && (
        <Industry />
      )}
      {SideBarState.visible && SideBarState.source === "solutions" && (
        <Solutions />
      )}
      {SideBarState.visible && SideBarState.source === "services" && (
        <Services />
      )}
      {SideBarState.visible && SideBarState.source === "aboutus" && <Company />}
    </>
  );
};

export default HeaderTemplate;
